import { ServerService } from 'app/model/services/api-services/server.service';
import { ModalLoginMessage, ModalLoginInfo } from './../../types/modal-login-message';
import { ModalMessagerService } from './../dialogs/modal-messager/modal-messager.service';
import { ProjectConfigDialogService } from './../dialogs/project-config-dialog/project-config-dialog.service';
import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {
  public view = 'b';
  @HostBinding('class.full-page') fullPage = true;
  constructor(private prjCfg: ProjectConfigDialogService, private server:ServerService, private messager: ModalMessagerService) {

  }
  ngOnInit(): void {
  }
  NavTo(target: string) {
    this.view = target;
  }
  ConfigProject() {
    this.prjCfg.Show();
  }
  ShowMessageTest() {
    this.messager.Notify('Yes, the modal messager is working');
  }
  ShowProgressTest() {
    const title = 'Are we there yet?';
    let pct = 10;
    this.messager.Progress('Almost there', false, pct / 100.0, title);
    this.UpdateProgress(pct, title);
  }
  UpdateProgress(pct: number, title: string) {
    if (pct < 100) {
      pct += 10;
      setTimeout(() => {
        this.messager.Progress('Almost there', false, pct / 100.0, title);
        this.UpdateProgress(pct, title);
      }, 1500)
    }

  }
  ShowConfirmTest() {
    this.messager.Confirm(`Uhh .. really? THAT's what you want to do?`, () => { }, null, `Just checkin'`);
  }
  ShowWarningTest() {
    this.messager.Notify(`That's actually a realy bad idea!`, true, `Danger Will Robinson!`);
  }
  ShowSaveFileTest() {
    this.messager.RequestExport(
      {
        extension: 'txt',
        mimeType: 'text/plain',
        defaultFileName: 'example',
        contents: JSON.stringify({ file: { name: "This is a test", by: 'Art Clifford', when: '' + Date() } })
      }, 'Download Sample File', undefined, undefined, 'Export Test');
  }
  ShowLoadFileTest() {
    this.messager.RequestImport(
      {
        readType: 'string',
        acceptedExtentions: ['txt', 'rccfg']
      }, 'Select a file to load', (contents) => {
        console.log(contents);
      }
    );
  }
  ShowLoginTest() {
    this.server.Login((message:ModalLoginInfo)=>{
      console.log(message);
    });
  }
  ShowLogoutTest() {
    this.server.Logout(()=>{
      console.log('user logged out');
    })
  }
}
